export default "__VITE_ASSET__CLAMPaIV__"